import { getFriendlyUrl } from 'js/utils/url.util';

const concatParams = (...arg) => [].slice.call(arg).join('_');

/**
 * Return unit for page
 * @param  {String} page
 * @return {String}
 */
export const getUnitForPage = (page) => concatParams(getFriendlyUrl(page), 'tab');
